import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.flags.js";
import ApprenticePeriodStep from './apprentice-period-step.vue';
import PracticeAreaStep from './practice-area-step.vue';
import { useApiErrorToast } from '@/modules/useApiErrorToast';
import { useRepositories } from '@/plugins/repositories';
import { useStore } from '@/store/useStore';
import { useTelemetry } from '@/plugins/telemetry';
import { useAuth } from '@/plugins/auth';
var stringToNumber = function stringToNumber(numString) {
  if (numString === '') return null;
  var numberedString = Number(numString);
  if (isNaN(numberedString)) return null;
  return numberedString;
};
export default defineComponent({
  components: {
    ApprenticePeriodStep: ApprenticePeriodStep,
    PracticeAreaStep: PracticeAreaStep
  },
  setup: function setup() {
    var route = useRoute();
    var repositories = useRepositories();
    var telemetry = useTelemetry();
    var store = useStore();
    var _useApiErrorToast = useApiErrorToast(),
      showRetriableErrorToast = _useApiErrorToast.showRetriableErrorToast;
    var canSkipInputProfile = ref(true);
    var loadingMe = ref(true);
    var _useAuth = useAuth(),
      user = _useAuth.user;
    canSkipInputProfile.value = user.flags.canSkipInputProfile;
    loadingMe.value = false;
    var step = ref(1);
    var organizationType = ref(null);
    var apprenticePeriod = ref('');
    var apprenticePeriodLabel = computed(function () {
      var _stringToNumber;
      return (_stringToNumber = stringToNumber(apprenticePeriod.value)) !== null && _stringToNumber !== void 0 ? _stringToNumber : '未入力';
    });
    var practices = ref([{
      practiceId: -1
    }]);
    var practicesSummary = ref(['']);
    var loadingOrganizationType = ref(true);
    repositories.users.getOrganizationType().then(function (res) {
      organizationType.value = res;
      loadingOrganizationType.value = false;
    });
    var backToRedirectUrl = function backToRedirectUrl() {
      var redirectUrl = route.query['redirect_url'];
      if (!Array.isArray(redirectUrl) && redirectUrl) {
        // KLUDGE: to workaround `Redirected when going from "/profile/wizard?redirect_url=%2F" to "/" via a navigation guard` nuxt error
        // TODO: think of using router methods instead
        window.location.href = redirectUrl;
      } else {
        window.location.href = '/profile';
      }
    };
    var submit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return repositories.users.putUserProfile(stringToNumber(apprenticePeriod.value), practices.value);
            case 3:
              store.commit('setFirstAccessOfTheDay', false);
              backToRedirectUrl();
              _context.next = 11;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              showRetriableErrorToast('プロフィールの送信に失敗しました');
              telemetry.sendErrorTelemetry(_context.t0, route);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }));
      return function submit() {
        return _ref.apply(this, arguments);
      };
    }();
    var skip = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return repositories.users.skipInputUserProfile();
            case 3:
              _context2.next = 8;
              break;
            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              // スキップに失敗した場合、翌日に再度表示されてしまうはずだが、当日の利用は問題ないためエラーをレポートするだけにする
              telemetry.sendErrorTelemetry(_context2.t0, route);
            case 8:
              store.commit('setFirstAccessOfTheDay', false);
              backToRedirectUrl();
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 5]]);
      }));
      return function skip() {
        return _ref2.apply(this, arguments);
      };
    }();
    var isLawOffice = computed(function () {
      return organizationType.value === 'law-office';
    });
    var isProfessionalOffice = computed(function () {
      return organizationType.value === 'professional-office';
    });
    var practiceLabel = computed(function () {
      return isLawOffice.value ? 'プラクティス' : '主なリサーチ分野';
    });
    var loading = computed(function () {
      return loadingMe.value || loadingOrganizationType.value;
    });
    return {
      submit: submit,
      canSkipInputProfile: canSkipInputProfile,
      skip: skip,
      step: step,
      apprenticePeriod: apprenticePeriod,
      apprenticePeriodLabel: apprenticePeriodLabel,
      practices: practices,
      practicesSummary: practicesSummary,
      isLawOffice: isLawOffice,
      isProfessionalOffice: isProfessionalOffice,
      practiceLabel: practiceLabel,
      loading: loading
    };
  }
});